import { useEffect, useState } from "react";
import { Bot } from "lucide-react";
import api from "@/lib/api";

export const AI_LABELS = { openai: "ChatGPT", claude: "Claude" };
const EVT = "ai-preference-updated";

// Record which model the user picked; the preference badge refreshes via a window event.
export async function recordAiPreference(provider, feature) {
  try {
    const { data } = await api.post("/ai/preference", { provider, feature });
    window.dispatchEvent(new CustomEvent(EVT, { detail: data }));
  } catch { /* non-blocking */ }
}

// Small "généré par X" pill placed next to an applied suggestion.
export const AiSourceTag = ({ provider, prefix = "généré par", testId }) => provider ? (
  <span className="inline-flex items-center gap-1 text-[10px] font-mono px-2 py-0.5 rounded-full bg-secondary/15 text-secondary border border-secondary/30" data-testid={testId}>
    <Bot size={10} /> {prefix} {AI_LABELS[provider] || provider}
  </span>
) : null;

// Shows the user's most-picked model with counts.
export default function ModelPreferenceBadge({ className = "" }) {
  const [pref, setPref] = useState(null);
  useEffect(() => {
    api.get("/ai/preference").then(({ data }) => setPref(data)).catch(() => {});
    const onUpd = (e) => setPref(e.detail);
    window.addEventListener(EVT, onUpd);
    return () => window.removeEventListener(EVT, onUpd);
  }, []);
  if (!pref || !pref.total) return null;
  const { openai, claude } = pref.counts;
  const pct = Math.round((Math.max(openai, claude) / pref.total) * 100);
  return (
    <div className={`inline-flex items-center gap-2 rounded-full border border-border bg-card px-2.5 py-1 text-[10px] font-mono ${className}`} data-testid="model-preference-badge" title={`ChatGPT ${openai} · Claude ${claude}`}>
      <Bot size={11} className="text-primary" />
      {pref.favorite ? (
        <span>Modèle préféré : <span className="text-primary font-bold" data-testid="model-preference-favorite">{pref.favorite_label}</span> · {pct}%</span>
      ) : (
        <span>Égalité ChatGPT / Claude</span>
      )}
      <span className="flex h-1.5 w-14 rounded-full overflow-hidden bg-muted">
        <span className="bg-[#10a37f]" style={{ width: `${(openai / pref.total) * 100}%` }} />
        <span className="bg-[#d97757]" style={{ width: `${(claude / pref.total) * 100}%` }} />
      </span>
      <span className="text-muted-foreground" data-testid="model-preference-counts">{openai}/{claude}</span>
    </div>
  );
}
